import React, { useState } from 'react';
import './Header.css';
import Navigation from '../Navigation/Navigation';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      {/* Add this new wrapper div */}
      <div className="header-wrapper">
        <div className="header-title-container">
          <h1 className="site-title">Sax and the City</h1>
          <p className="site-subtitle">Evan Reid</p>
        </div>

        <Navigation menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </button>
      </div>
    </header>
  );
}

export default Header;